import { GameConstants } from "./../../../GameConstants";
import { BoardScene } from "./../BoardScene";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./../BoardManager";
import { GameVars } from "../../../GameVars";
import { Card } from "./Card";
import { AudioManager } from "../../../AudioManager";

export class DeckContainer extends Phaser.GameObjects.Container {

    private cards: Card[];

    private deckInputZone: Phaser.GameObjects.Zone;
    private wasteInputZone: Phaser.GameObjects.Zone;
    
    constructor(scene: Phaser.Scene) {

        super(scene);

        this.cards = [];

        for (let i = 0; i < 52; i++) {
            let card = new Card(this.scene, 0, 700, GameVars.cards[i]);
            this.add(card);
            this.cards.push(card);
        }

        this.deckInputZone = new Phaser.GameObjects.Zone(this.scene, -94, 0, 160, 220);
        this.deckInputZone.setInteractive();
        this.deckInputZone.on("pointerdown", this.deckInputDown, this);
        this.add(this.deckInputZone);

        this.wasteInputZone = new Phaser.GameObjects.Zone(this.scene, 94, 0, 160, 220);
        this.wasteInputZone.setInteractive();
        this.wasteInputZone.on("pointerdown", this.wasteInputDown, this);
        this.add(this.wasteInputZone);

        this.deckInputZone.input.enabled = false;
        this.wasteInputZone.input.enabled = false;
    }

    public startGame(): void {

        this.cardsToDeck();

        this.scene.time.addEvent({ delay: 3500, callback: () => {
            this.dealCards();
        }, callbackScope: this});
    }

    public cardsToDeck(): void {

        for (let i = 0; i < 52; i++) {
            this.scene.tweens.add({
                targets: this.cards[i],
                x: -94,
                y: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: i * 10,
                duration: 500,
                onStart: () => {
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                },
                onStartScope: this
            });
        }
    }

    public hideCards(): void {

        for (let i = 0; i < 52; i++) {
            this.scene.tweens.add({
                targets: this.cards[i],
                x: 0,
                y: 700,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: i * 10,
                duration: 500,
                onStart: () => {
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                },
                onStartScope: this
            });
        }
    }

    public dealCards(): void {

        BoardManager.dealCards();

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 4; j++) {
                if (GameVars.players[j].tokens > 0) {
                    this.dealCard(j, i, true);
                }
            }
        }

        this.cardToWaste();
    }

    public enableInputs(): void {

        this.deckInputZone.input.enabled = true;
        this.wasteInputZone.input.enabled = true;
    }

    public disableInputs(): void {

        this.deckInputZone.input.enabled = false;
        this.wasteInputZone.input.enabled = false;
    }

    public allCardsToDeck(): void {

        // las cartas van hacia deck
        for (let i = 0; i < 52; i++) {
            if (this.cards[i].x !== -94) {

                this.scene.tweens.add({
                    targets: this.cards[i],
                    x: -94,
                    y: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    delay: Math.random() * 200,
                    duration: 500,
                    onStart: () => {
                        this.bringToTop(this.cards[i]);
                        this.cards[i].unflip();
                        AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                    },
                    onStartScope: this
                });
            } 
        }

        // cartas se dividen en dos grupos abajo
        for (let i = 0; i < 52; i++) {
            this.scene.tweens.add({
                targets: this.cards[i],
                x: i % 2 === 0 ? -150 : 150,
                y: BoardContainer.currentInstance.playerContainer.y,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: 1000,
                duration: 500,
                onStart: () => {
                    this.bringToTop(this.cards[i]);
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                },
                onStartScope: this
            }); 
        }

        // cartas de nuevo al deck
        for (let i = 0; i < 52; i++) {
            this.scene.tweens.add({
                targets: this.cards[i],
                x: -94,
                y: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: i * 50 + 1750,
                duration: 250,
                onStart: () => {
                    this.bringToTop(this.cards[i]);
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                },
                onStartScope: this
            }); 
        }

        this.scene.time.addEvent({ delay: 5000, callback: () => {
            this.dealCards();
        }, callbackScope: this});
    }

    public dealCard(player: number, card: number, extraDelay: boolean, unflip?: boolean): void {

        let deckCard = this.getCard(GameVars.players[player].cards[card]);
        
        this.moveCardToPlayer(player, card, deckCard, extraDelay, unflip);
    }

    public enableInputPlayerCards(): void {

        for (let i = 0; i < 4; i++) {
            let deckCard = this.getCard(GameVars.players[0].cards[i]);
            deckCard.enableInput();
        }
    }

    public disableInputPlayerCards(): void {

        for (let i = 0; i < 4; i++) {
            let deckCard = this.getCard(GameVars.players[0].cards[i]);
            deckCard.disableInput();
        }
    }

    public cardPlayerToWaste(): void {

        let deckCard = this.getCard(GameVars.topCardWaste);

        this.scene.tweens.add({
            targets: deckCard,
            x: 94,
            y: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onStart: () => {
                this.bringToTop(deckCard);
                deckCard.flip();
                AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
            },
            onStartScope: this,
            onComplete: () => {
                BoardManager.nextTurn(true);
            },
            onCompleteScope: this
        });

        if (GameVars.needStop !== -1) {
            BoardContainer.currentInstance.stop.visible = true;
            BoardContainer.currentInstance.stop.setPosition(BoardContainer.POSITION_STOP_BUTTON[GameVars.needStop].x, BoardContainer.POSITION_STOP_BUTTON[GameVars.needStop].y);
        } else {
            BoardContainer.currentInstance.stop.visible = false;
        }

    }

    public getCard(cardValue: CardValue): Card {

        for (let i = 0; i < this.cards.length; i++) {
            if (cardValue === this.cards[i].cardValue) {
                return this.cards[i];
            }
        }
    }

    public changeBack(): void {

        for (let i = 0; i < this.cards.length; i++) {
            this.cards[i].changeBack();
        }
    }

    private cardToWaste(): void {

        BoardManager.cardToWaste();

        let deckCard = this.getCard(GameVars.topCardWaste);

        this.scene.tweens.add({
            targets: deckCard,
            x: 94,
            y: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 3 * 4 * 250,
            duration: 500,
            onStart: () => {
                this.bringToTop(deckCard);
                deckCard.flip();
                AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
            },
            onStartScope: this,
            onComplete: () => {
                if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 0) {
                    BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_1);
                    GameVars.tutorialCount = 1;
                } else {
                    BoardManager.nextTurn(false);
                }   
            },
            onCompleteScope: this
        });

    }

    private moveCardToPlayer(player: number, card: number, deckCard: Card, extraDelay: boolean, unflip?: boolean): void {

        if (player === 0) {

            this.scene.tweens.add({
                targets: deckCard,
                x: BoardContainer.currentInstance.playerContainer.x - 140 + 95 * card,
                y: BoardContainer.currentInstance.playerContainer.y,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: extraDelay ? player * 250 + card * 4 * 250 : 0,
                duration: 500,
                onStart: () => {

                    this.bringToTop(deckCard);
                    deckCard.flip();
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                },
                onStartScope: this,
                onComplete: () => {
                    if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 6) {
                        BoardScene.currentInstance.showTutorial(GameConstants.TUTORIAL_1_6);
                        GameVars.tutorialCount = 7;
                    }
                },
                onCompleteScope: this
            });
            
        } else {
            this.scene.tweens.add({
                targets: deckCard,
                x: BoardContainer.currentInstance.adversariesContainer[player - 1].x - 70 + 40 * card,
                y: BoardContainer.currentInstance.adversariesContainer[player - 1].y,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: extraDelay ? player * 250 + card * 4 * 250 : 0,
                duration: 500,
                onStart: () => {
                    this.bringToTop(deckCard);
                    AudioManager.playSound("cards_" + (Math.random() > .5 ? "in" : "out"));
                    if (unflip) {
                        deckCard.unflip();
                    }
                },
                onStartScope: this
            });
        }
    }

    private deckInputDown(): void {

        if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 5) {
            BoardScene.currentInstance.removeTutorial();
            GameVars.tutorialCount = 6;
        }
        
        BoardManager.deckCardToPlayer();
        this.disableInputs();
    }

    private wasteInputDown(): void {

        if (GameVars.gameData.showTutorial && GameVars.tutorialCount === 5) {
            BoardScene.currentInstance.removeTutorial();
            GameVars.tutorialCount = 6;
        }
        
        BoardManager.wasteCardToPlayer();
        this.disableInputs();
    }
}
